export default __webpack_public_path__ + "static/svelte-table-component-1ba39261e4716a0c36f0280a5f8c1b38.png";